export const UPLOAD_DOCUMENT = `
mutation ($file: Upload!, $requirements: String!) { 
    response: uploadDocumentForValidation(file: $file, requirements: $requirements) {
        id,
        scanStatus
    } 
}`

export const CHECK_UPLOAD_STATUS = `
mutation CheckDocumentScanStatus($fileScanIds: [Int!]!) {
  response: checkDocumentScanStatus(input: { fileScanIds: $fileScanIds }) {
    id
    scanStatus
  }
}`

export const COMMIT_UPLOAD = `
mutation CommitDocuments($fileScanIds: [Int!]!, $associatedRequirements: [String!]!, $claimId: Int!) {
  response: commitDocuments(
    input: {
      fileScanIds: $fileScanIds
      associatedRequirements: $associatedRequirements
      claimId: $claimId
    }
  ) {
    claimId
    documentLocation
    documentName
  }
}`